import { render, staticRenderFns } from "./MailSegnalazioni.vue?vue&type=template&id=9f83ee9a&scoped=true"
import script from "./MailSegnalazioni.vue?vue&type=script&lang=js"
export * from "./MailSegnalazioni.vue?vue&type=script&lang=js"
import style0 from "./MailSegnalazioni.vue?vue&type=style&index=0&id=9f83ee9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f83ee9a",
  null
  
)

export default component.exports